import { actions as modalActions } from '@saucelabs/sl-container-modal';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import { name as assignTeamsToGroupModalName } from './../../teams/components/AssignTeamsToGroupModal';
import { actions as groupsActions } from './../groups';
import * as actions from './actions';
import * as selectors from './selectors';


export const autocompleteGetTeams = (payload) => (dispatch, getState) => {
  const me = getState().user;

  if (me.isOrgAdmin()) {
    return dispatch(actions.autocompleteGetTeams(payload));
  }

  // No point in filtering what should be a list of 1 team
  return dispatch(actions.autocompleteGetOwnTeams({ results: me.teams }));
};

export const createTeam = (payload) => (dispatch, getState) => {
  const organizationId = getState().user.get('organization').id;
  return dispatch(actions.createTeam({ organizationId, ...payload }));
};

export const removeTeam = (teamId) => (dispatch) => (
  dispatch(actions.removeTeam({ id: teamId }))
    .then(
      () => teamId,
      (error) => {
        throw Error(error.response.data[0]);
      })
);

export const showAssignTeamsToGroupModal = () => (dispatch) => (
  dispatch(groupsActions.getGroupList()).then(() => (
    dispatch(modalActions.showModal(assignTeamsToGroupModalName))
  ))
);

export const assignTeamsToGroup = (payload) => (dispatch, getState) => {
  const allTeams = selectors.teamsSelector(getState()).teams;

  const assignActions = payload.selectedTeams.map((teamId) => (
    actions.assignTeamToGroup({ teamId, groupId: payload.groupId })
  ));

  const dispatchedActions = assignActions.map((action) => (
    dispatch(action)
      .catch(({ teamId }) => {
        const teamName = allTeams.get(teamId).name;
        dispatch(notificationActions.notifyDanger(`Unable to assign team ${teamName} to the group.`));
      })
  ));

  return Promise.all(dispatchedActions)
    .then((responses) => {
      const teamNames = responses
        .filter((response) => response)
        .map((response) => allTeams.get(response.teamId).name);

      const teamWord = teamNames.length === 1 ? 'team' : 'teams';

      if (teamNames.length) {
        dispatch(notificationActions.notifySuccess(`Successfully assigned the following ${teamWord} to the group: ${teamNames.join(', ')}`));
      }

      return dispatch(actions.getTeamList());
    });
};
